// Import style file
import {
    ImageEditorContainer,
    ImageEditorTitle,
    ImageLayout,
    ImageContainer,
    Image,
    ImportLabel,
    DeleteButton,
    CloseButton,
    Icon,
    Overlay,
} from './style';

// Import assets
import imageNotFound from '../../assets/images/imageNotFound.png';

import { ReactComponent as removeIcon } from '../../assets/icons/remove.svg';
import { ReactComponent as closeIcon } from '../../assets/icons/close.svg';

// Import text
import productTexts from '../../texts/product';

// Component to allow user to insert photo in the website
function ImageEditor({
    ICON_WIDTH = 30,
    productName = null,
    images = null,
    addImage = null,
    removeImage = null,
    onClose = null,
}) {
    async function handleFileChange(e) {
        // Get the file if it exist
        const file = e.target.files?.[0];
        if (!file) return;

        // Add the file to the image list
        await addImage(file);
    }

    return (
        <>
            <Overlay
                onClick={() => {
                    onClose();
                }}
            />
            <ImageEditorContainer>
                <CloseButton
                    onClick={() => {
                        onClose();
                    }}
                >
                    <Icon as={closeIcon} width={ICON_WIDTH}></Icon>
                </CloseButton>
                <ImageEditorTitle>{productTexts.imageAddText}</ImageEditorTitle>
                <ImageLayout>
                    {images &&
                        images.length > 0 &&
                        images.map((image) => (
                            <ImageContainer key={image.id}>
                                <DeleteButton
                                    onClick={() => removeImage(image.id)}
                                >
                                    <Icon
                                        as={removeIcon}
                                        width={ICON_WIDTH}
                                    ></Icon>
                                </DeleteButton>
                                {image.url ? (
                                    <Image
                                        src={image.url}
                                        alt={productName}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = imageNotFound;
                                        }}
                                    />
                                ) : (
                                    <Image
                                        src={imageNotFound}
                                        alt={productName}
                                    />
                                )}
                            </ImageContainer>
                        ))}
                </ImageLayout>
                <input
                    id="file-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                />
                <ImportLabel htmlFor="file-upload">
                    {productTexts.imageImport}
                </ImportLabel>
            </ImageEditorContainer>
        </>
    );
}

export default ImageEditor;
